import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "input", "form"]

  connect() {
    this.scrollToBottom()
    this.observeMessages()
  }

  submit(event) {
    event.preventDefault()
    this.formTarget.requestSubmit()
  }

  fillSuggestion(event) {
    this.inputTarget.value = event.currentTarget.dataset.suggestion
    this.inputTarget.focus()
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }
  }

  observeMessages() {
    if (!this.hasMessagesTarget) return

    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
      this.clearInput()
    })

    this.observer.observe(this.messagesTarget, { childList: true, subtree: true })
  }

  clearInput() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
